// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3514":"ee491ced","8261":"9d423da9","9634":"c106a5c5"}[chunkId] + ".chunk.css";
};